var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3431A883-165A-4582-A141-E7BFD2CDB0D2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 59.99995 0 59.99995 59.99995 0 59.99995"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-Help-Page_V3",
    transform: "translate(-992.000000, -901.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(960.000000, 869.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "other-resources",
    transform: "translate(32.000050, 32.000050)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C13.431,0 0,13.431 0,30 C0,46.569 13.431,60 30,60 C46.5685,60 60,46.569 60,30 C60,13.431 46.5685,0 30,0 M30,1.5 C45.715,1.5 58.5,14.285 58.5,30 C58.5,45.715 45.715,58.5 30,58.5 C14.285,58.5 1.5,45.715 1.5,30 C1.5,14.285 14.285,1.5 30,1.5",
    id: "Fill-1",
    fill: "#EDEBE9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 16.1594,
    y1: 45.9346,
    x2: 45.6344,
    y2: 45.9346,
    id: "Stroke-4",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(6.999950, 15.499950)",
    stroke: "#05314D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.72585,5.29985 L28.02785,5.55735 C28.22685,5.64235 28.61135,5.84835 28.75385,6.22335 C28.88785,6.57535 28.78685,7.02085 28.45385,7.54785 C28.42835,7.58835 28.41235,7.63335 28.40635,7.68085 C28.40485,7.69485 28.20785,9.12885 27.40135,9.36385 C27.31135,9.38985 27.23785,9.45385 27.19935,9.53835 C26.41985,11.24235 25.14385,12.25935 23.78685,12.25935 C22.42935,12.25935 21.15335,11.24235 20.37435,9.53835 C20.33785,9.45885 20.26785,9.39685 20.18585,9.36835 C20.16885,9.36235 19.76585,9.21735 19.44135,8.72435 C19.14585,8.32085 18.43035,7.10535 18.67035,6.33435 C18.76235,6.03885 18.99285,5.83085 19.37485,5.69785 C19.53485,5.64285 19.62385,5.47235 19.57885,5.30935 C19.57235,5.28735 18.98785,3.10335 20.44135,2.07935 C20.51835,2.02435 20.56785,1.93585 20.57585,1.84185 C20.58185,1.77035 20.76035,0.09235 23.59935,0.09235 C23.69185,0.09235 23.78635,0.09385 23.88385,0.09785 C23.89585,0.09835 23.90785,0.09785 23.91935,0.09685 C23.92485,0.09685 23.99535,0.09185 24.11335,0.09185 C24.60885,0.09185 26.29785,0.18235 27.22385,1.34385 C27.88785,2.17685 28.04935,3.40735 27.70785,5.00085 L26.80235,5.60735 C27.08485,4.81235 26.93735,4.08685 26.54585,3.65985 C25.79485,2.83985 24.70635,2.79985 24.65135,2.79835 L22.00385,2.79835",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5076,11.54205 L21.5076,13.56705 C21.5076,13.56705 21.8366,14.38905 22.7756,14.62805",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0076,11.54205 L26.0076,13.56705 C26.0076,13.56705 25.5576,14.99155 24.2076,14.99155 L24.0016,16.11655",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5076,13.56695 C21.5076,13.56695 17.4826,12.64195 16.2826,14.69195 C15.7926,15.52895 14.9066,17.61045 14.2986,19.03395 C13.9841,19.76995 13.0586,20.00945 12.4251,19.51895 L8.3816,16.39145 C7.8066,15.94695 6.9696,16.12495 6.6261,16.76545 C6.3666,17.24895 6.4761,17.84795 6.8896,18.20795 L12.6791,23.25445 C13.1811,23.69195 13.9411,23.64795 14.3891,23.15495 L16.4266,20.91295 C16.7686,20.53695 17.3906,20.83645 17.3096,21.33845 L17.1826,29.59195",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.28615,13.56695 C26.28615,13.56695 30.31115,12.64195 31.51115,14.69195 C32.00115,15.52895 32.88715,17.61045 33.49515,19.03395 C33.81015,19.76995 34.73515,20.00945 35.36915,19.51895 L39.41265,16.39145 C39.98765,15.94695 40.82415,16.12495 41.16815,16.76545 C41.42715,17.24895 41.31765,17.84795 40.90415,18.20795 L35.11465,23.25445 C34.61265,23.69195 33.85315,23.64795 33.40515,23.15495 L31.36715,20.91295 C31.02515,20.53695 30.40315,20.83645 30.48415,21.33845 L30.31115,29.59195",
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-15",
    points: "15.1287 10.3394 15.1287 3.5294 6.7047 3.5294 6.7047 10.5319"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.36185,
    y1: 5.5977,
    x2: 8.60985,
    y2: 5.5977,
    id: "Stroke-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.1299,
    y1: 7.628,
    x2: 8.6099,
    y2: 7.628,
    id: "Stroke-19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.1299,
    y1: 9.6578,
    x2: 8.6099,
    y2: 9.6578,
    id: "Stroke-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79055,0.9483 L5.60305,0.9483 C5.44655,0.9483 5.29555,1.0078 5.18205,1.1153 L0.38255,6.4888 C0.25955,6.6048 0.18955,6.7663 0.18955,6.9358 C0.18955,7.1048 0.25955,7.2663 0.38255,7.3823 L5.18205,12.7553 C5.29555,12.8633 5.44655,12.9228 5.60305,12.9228 L15.79055,12.9228",
    id: "Stroke-23"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-25",
    points: "39.3545 5.20955 36.521 7.15005 32.7745 3.65905 41.256 3.65905 41.256 10.17905 33.042 10.17905"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.251,
    y1: 5.91315,
    x2: 30.5825,
    y2: 5.91315,
    id: "Stroke-27"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.48585,
    y1: 7.8892,
    x2: 30.99235,
    y2: 7.8892,
    id: "Stroke-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0032,0.9483 L42.1907,0.9483 C42.3472,0.9483 42.4982,1.0078 42.6122,1.1153 L47.4117,6.4888 C47.5347,6.6048 47.6047,6.7663 47.6047,6.9358 C47.6047,7.1048 47.5347,7.2663 47.4117,7.3823 L42.6122,12.7553 C42.4982,12.8633 42.3472,12.9228 42.1907,12.9228 L32.0032,12.9228",
    id: "Stroke-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85255,19.0318 C23.85255,19.0703 23.82155,19.1018 23.78255,19.1018 C23.74405,19.1018 23.71305,19.0703 23.71305,19.0318 C23.71305,18.9933 23.74405,18.9618 23.78255,18.9618 C23.82155,18.9618 23.85255,18.9933 23.85255,19.0318 Z",
    id: "Stroke-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85255,22.07865 C23.85255,22.11715 23.82155,22.14865 23.78255,22.14865 C23.74405,22.14865 23.71305,22.11715 23.71305,22.07865 C23.71305,22.04015 23.74405,22.00865 23.78255,22.00865 C23.82155,22.00865 23.85255,22.04015 23.85255,22.07865 Z",
    id: "Stroke-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85255,25.12555 C23.85255,25.16405 23.82155,25.19555 23.78255,25.19555 C23.74405,25.19555 23.71305,25.16405 23.71305,25.12555 C23.71305,25.08705 23.74405,25.05555 23.78255,25.05555 C23.82155,25.05555 23.85255,25.08705 23.85255,25.12555 Z",
    id: "Stroke-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85255,28.17195 C23.85255,28.21045 23.82155,28.24195 23.78255,28.24195 C23.74405,28.24195 23.71305,28.21045 23.71305,28.17195 C23.71305,28.13345 23.74405,28.10195 23.78255,28.10195 C23.82155,28.10195 23.85255,28.13345 23.85255,28.17195 Z",
    id: "Stroke-39"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherResources);
export default __webpack_public_path__ + "static/media/other-resources.cf96d8f3f42775a49873529620df2486.svg";
export { ForwardRef as ReactComponent };